module.exports = __webpack_public_path__ + "static/symbol-control-96c08b23335150302a616676b4b91023.png";